// Track the last few items the user opened from the global Command
// Palette (Cmd+K). Stored as a tiny JSON array in localStorage so we
// can render a "Recent" group when the palette opens. Capped to 5 to
// keep the surface uncluttered.
//
// Each entry is shape-stable:
//   { type: "wo" | "client" | "nav" | "action",
//     id:   string,           // unique within the type
//     label: string,          // what we show in the row
//     hint?: string,          // optional sub-label (e.g. WO number, city)
//     path:  string,          // route to navigate to on click
//     state?: object }        // optional location state for the route

const KEY = "cmdk_recents_v1";
const MAX = 5;

export function getRecents() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(0, MAX) : [];
  } catch {
    return [];
  }
}

export function pushRecent(entry) {
  if (!entry || !entry.id || !entry.type) return;
  try {
    const current = getRecents();
    // De-dupe on (type, id) so re-opening the same thing just bumps
    // it to the top instead of producing 5 copies of one client.
    const filtered = current.filter(
      (r) => !(r.type === entry.type && r.id === entry.id),
    );
    const next = [entry, ...filtered].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // localStorage can throw in private mode / when full — silently
    // drop the write. Recents are best-effort; missing them never
    // breaks the palette.
  }
}

export function clearRecents() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* no-op */
  }
}
